import {
  getDownloadURL,
  getStorage as getFirebaseStorage,
  ref,
  uploadBytes,
} from 'firebase/storage';
import { firebaseApp } from './init';

export const firebaseStorage = getFirebaseStorage(firebaseApp);

export const uploadFile = async (path: string, file: Blob) => {
  if (!firebaseStorage || !path) return;

  const fileRef = ref(firebaseStorage, path);
  const response = await uploadBytes(fileRef, file);
  const url = await getDownloadURL(response.ref);
  return url;
};
